import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomersService } from '../services/customers/customers-service';

@Injectable()
export class CustomerLicensePlateExistsValidator {

  debouncer: any;
  private id: number|null;

  excludeId(id: number|null) {
    this.id = id;
    return {checkLicensePlate: this.checkLicensePlate};
  }

  checkLicensePlate(control: FormControl): any {
    let self: CustomerLicensePlateExistsValidator = this;
    return new Promise(resolve => {
      this.debouncer = setTimeout(() => {

        if(String(control.value).trim().length < 1) {
          resolve(null);
          return;
        }

        this.custService
          .search({License_Plate: String(control.value).trim(), _exclude_status: ['canceled', 'expired']})
          .subscribe(
            (res) => {
              if(res.filter(function(r){

                if(r.hasOwnProperty("id"))
                {
                  return String(r.License_Plate).trim().toLowerCase() === String(control.value).trim().toLowerCase() 
                     && (self.id && self.id>0 ? self.id.toString() !== r.id.toString() : true);
                }

                return String(r.License_Plate).trim().toLowerCase() === String(control.value).trim().toLowerCase();
              }).length > 0) {
                resolve({"license_plate_taken": true});
              }
              else {
                resolve(null);
              }
            },
            (err) => {
              resolve({"can't reach server": true});
            }
          );
      }, 350);
    });
  }

  constructor(public custService: CustomersService) {}
}


// WEBPACK FOOTER //
// ./src/validators/customer-license-plate-exists.ts